import { type UseMutationResult, useMutation } from '@tanstack/react-query';

import api from '@/axios';
import { CREATE_PURCHASE_ORDER_KEY } from '@/keys';
import type { PurchaseOrder } from '@/types/core/purchase-order/purchase-order';

export type CreatePurchaseOrderParams = {
  lotSizingId: string;
};

export type CreatePurchaseOrderResponse = Pick<PurchaseOrder, 'id'>[];

const createPurchaseOrder = async (
  params: CreatePurchaseOrderParams,
): Promise<CreatePurchaseOrderResponse> => {
  const response = await api.post<CreatePurchaseOrderResponse>(
    '/purchase-orders',
    params,
  );
  return response.data;
};

export const useCreatePurchaseOrder = (): UseMutationResult<
  CreatePurchaseOrderResponse,
  Error,
  CreatePurchaseOrderParams
> =>
  useMutation({
    mutationKey: CREATE_PURCHASE_ORDER_KEY,
    mutationFn: createPurchaseOrder,
  });
